/** Success / queued / stored-only state shown after a submit. */
import type { ReviewResponse } from '@pghbites/shared';
import { Header } from './Header.js';

interface ResultScreenProps {
  response: ReviewResponse;
  onAnother: () => void;
}

const EMOJI: Record<ReviewResponse['status'], string> = {
  posted: '🖤💛',
  queued: '🕒',
  stored_only: '✅',
  capped: '💛',
};

export function ResultScreen({ response, onAnother }: ResultScreenProps) {
  return (
    <div className="screen">
      <div className="screen-scroll">
        <Header />
        <main className="center-screen result-card">
          <div className="result-emoji" aria-hidden="true">{EMOJI[response.status]}</div>
          <p>{response.message}</p>
          {response.draft && <blockquote className="result-draft">{response.draft}</blockquote>}
          <p className="result-meta">
            {response.status === 'posted' && 'Posted to the reviews channel.'}
            {response.status === 'queued' && 'A mod will take a quick look before it goes live.'}
            {response.status === 'stored_only' && 'Saved. (Channel posting isn’t wired up yet.)'}
            {response.status === 'capped' && 'You can leave more tomorrow.'}
          </p>
          <button type="button" className="btn btn-secondary" onClick={onAnother}>
            Leave another review
          </button>
        </main>
      </div>
    </div>
  );
}
